import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { LoaderSm, LoaderXs } from '@sketchnote/shared-components';
import * as React from 'react';

import { useLoaderStore } from './useLoaderStore';

export const LoaderApp = () => {
  const { isLoading, setIsLoading } = useLoaderStore();
  return (
    <Modal
      isOpen={isLoading}
      onClose={() => {
        setIsLoading(false);
      }}
    >
      <ModalOverlay />
      <ModalContent
        style={{ width: '20rem', padding: '24px', marginTop: '20rem', borderRadius: '8px' }}
      >
        <LoaderXs className="mx-auto text-xss" />
        <p className="mt-20 mx-auto">Loading...</p>
      </ModalContent>
    </Modal>
  );
};
